<template>
  <div>
    <el-steps :active="active" align-center finish-status="success">
      <el-step title="Selecionar colunas"></el-step>
      <el-step title="Importar"></el-step>
    </el-steps>

    <el-card shadow="always">
      <div>
        <el-form
          ref="form"
          :model="importForm"
          label-width="120px"
          v-if="active === 0"
        >
          <el-row :gutter="5">
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="6">
              <el-form-item :label="$t('usar')" prop="use">
                <el-select
                  ref="user"
                  v-model="importForm.use"
                  placeholder="Selecione  uma opção"
                >
                  <el-option key="1" label="Separador" value="1"></el-option>
                  <el-option key="2" label="Tamanho Fixo" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="6">
              <el-form-item :label="$t('meus-layouts')" prop="layout">
                <el-select
                  ref="user"
                  v-model="importForm.use"
                  placeholder="Selecione  uma opção"
                >
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <br />
        <el-upload
          v-if="active === 1"
          class="upload-demo"
          drag
          action="/api/import/upload/"
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Arraste o arquivo ou <em>clique para aqui para enviar</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            Arquivos csv/txt com a listagem de pre-postagens
          </div>
        </el-upload>

        <el-transfer
          v-if="active === 0"
          filterable
          :filter-method="filterMethod"
          filter-placeholder="Campos"
          v-model="value"
          :titles="['Disponiveis', 'Selecionados']"
          :data="tableData"
        >
          <el-button
            class="transfer-footer"
            slot="right-footer"
            size="small"
            type="warning"
            @click="save()"
            >Salvar Layout</el-button
          >
        </el-transfer>
        <el-row :gutter="5">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="4" :offset="16">
            <el-button v-if="active > 0" @click="back()">Voltar</el-button>
            <el-button v-if="active < 1" type="primary" @click="next()"
              >Prosseguir</el-button
            >
            <el-button v-if="active == 1" type="warning" @click="finish()"
              >Finalizar</el-button
            >
          </el-col>
        </el-row>
        <el-row :gutter="5" v-if="active === 0">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <el-table size="mini" :data="tableData" style="width: 100%">
              <el-table-column prop="label"></el-table-column>
              <el-table-column prop="description"></el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import { UserService } from "@/services/users/user.services";
import { LayoutService } from "@/services/customers/layout.services";
import { i18n } from "@/plugin/i18n";

export default {
  name: "ImportPrepost",
  props: ["state"],
  props: ["type"],
  methods: {
    save() {
      const vm = this;
      if (vm.value.length == 0) {
        this.$message({
          type: "error",
          message: "Selecione ao menos um campo para salvar o layout",
        });
        return false;
      }
      this.$prompt("Informe um nome para o layout", "Salvar", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        inputPlaceholder: "Informe um nome",
        inputErrorMessage: "É obrigatório informar um nome",
        inputValidator: function (v) {
          if (!v) {
            return false;
          }
        },
      })
        .then(({ value }) => {
          const data = {
            name: value,
            fields: vm.value,
            type: vm.$props.type,
          };
          const loading = vm.$loading({
            lock: true,
            text: i18n.tc("carregando"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          LayoutService.add(data)
            .then((response) => {
              this.$message({
                type: "success",
                message: i18n.tc("layout-salvo-sucesso"),
              });
            })
            .catch((error) => {
              this.$message({
                type: "error",
                message: error,
              });
            })
            .finally(() => loading.close());
        })
        .catch(() => {});
    },
    next() {
      const vm = this;
      vm.active++;
    },
    back() {
      const vm = this;
      vm.active--;
    },
  },
  data() {
    return {
      importForm: {
        use: "",
        department: "",
      },
      filterMethod(query, item) {
        return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
      },
      active: 0,
      value: [],
      customer: "",
      tableData: [
        {
          label: "OBJETO",
          key: "OBJETO",
          description: "NÚMERO DA ETIQUETA",
        },
        {
          label: "DATA REC",
          key: "DATA REC",
          description: "DATA RECEBIMENTO",
        },
        {
          label: "NOME REC",
          key: "NOME REC",
          description: "NOME DA PESSOA QUE RECEBEU",
        },
        {
          label: "NUMERO REC",
          key: "NUMERO REC",
          description: "NÚMERO DO DOCUMENTO DA PESSOA QUE RECEBEU",
        },
        {
          label: "ESPAÇOS",
          key: "ESPAÇOS",
          description:
            "RELACIONADO A CAMPOS A SEREM DESCONSIDERADOS NA IMPORTAÇÃO",
        },
      ],
    };
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {})
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
